/**
 * @classdesc The `PillType` class is the source of truth for which pill types currently exist for the
 * popular searches pills feature.
 */
export default class PillType {
  /**
   * Gets the details for the HotDeals pill type.
   * @returns {{ name: string, text: string }} The pill details for this type.
   */
  static get HotDeals() {
    return this.getInstance('hotDeals', 'Hot deals');
  }

  /**
   * Gets the details for the Adult pill type.
   * @returns {{ name: string, text: string }} The pill details for this type.
   */
  static get Adult() {
    return this.getInstance('adult', '55+ Communities');
  }

  /**
   * Gets the details for the ComingSoon pill type.
   * @returns {{ name: string, text: string }} The pill details for this type.
   */
  static get ComingSoon() {
    return this.getInstance('comingSoon', 'Coming soon');
  }

  /**
   * Gets the details for the FloorPlans pill type.
   * @returns {{ name: string, text: string }} The pill details for this type.
   */
  static get FloorPlans() {
    return this.getInstance('floorPlans', 'Floor plans');
  }

  /**
   * Gets the details for the QuickMoveIns pill type.
   * @returns {{ name: string, text: string }} The pill details for this type.
   */
  static get QuickMoveIns() {
    return this.getInstance('quickMoveIns', 'Quick move-ins');
  }

  /**
   * Gets the details for the Condo and Townhomes pill type.
   * @returns {{ name: string, text: string }} The pill details for this type.
   */
  static get CondosAndTownhomes() {
    return this.getInstance('condosAndTownhomes', 'Condos & Townhomes');
  }

  /**
   * The getInstance function returns an instance of the PillType class based on the
   * provided key, creating a new instance if one does not already exist.
   * @param {string} name A unique identifier used to determine which instance of PillType class to retrieve.
   * @param {string} text The text that should be rendered for a given PillType class.
   * @returns {PillType} The instance of the PillType class with the specified key.
   */
  static getInstance(name, text) {
    if (!this.instances[name]) {
      this.instances[name] = new PillType(name, text);
    }
    return this.instances[name];
  }

  constructor(name, text) {
    this.name = name;
    this.text = text;
  }

  /**
   * Returns the name of the pill type as a string.
   * @returns {string} The name of the pill type.
   */
  toString() {
    return this.name;
  }
}

Object.defineProperty(PillType, 'instances', { value: {} });
